import React from 'react';
import { usePartnerData } from '../../../hooks/usePartnerData';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ title, icon, currency = false, className = '' }) => {
  const { metrics, loading, error } = usePartnerData();

  if (loading) {
    return (
      <div className={`bg-card border border-border rounded-lg p-6 shadow-sm ${className}`}>
        <div className="animate-pulse">
          <div className="h-4 bg-muted rounded w-3/4 mb-2"></div>
          <div className="h-8 bg-muted rounded w-1/2 mb-2"></div>
          <div className="h-3 bg-muted rounded w-1/4"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`bg-card border border-border rounded-lg p-6 shadow-sm ${className}`}>
        <div className="text-center text-muted-foreground">
          <Icon name="AlertCircle" size={24} className="mx-auto mb-2" />
          <p className="text-sm">Erreur de chargement</p>
        </div>
      </div>
    );
  }

  const getValue = () => {
    switch (title) {
      case 'Total Partenaires':
        return metrics?.totalPartners;
      case 'Campagnes Actives':
        return metrics?.activeCampaigns;
      case 'Commissions Payées':
        return metrics?.totalCommissions;
      case 'Croissance Mensuelle':
        return metrics?.monthlyGrowth;
      default:
        return 0;
    }
  };

  const value = getValue();
  const formattedValue = currency 
    ? new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0
      })?.format(value)
    : new Intl.NumberFormat('fr-FR')?.format(value);

  const change = '+' + Math.floor(Math.random() * 20 + 5) + '%'; // Mock change for demo
  const changeType = 'positive';

  return (
    <div className={`bg-card border border-border rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={24} className="text-accent" />
          </div>
          <div>
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <div className="text-2xl font-bold text-card-foreground">
          {formattedValue}
        </div>
        
        <div className="flex items-center space-x-2">
          <div className={`flex items-center space-x-1 text-sm ${
            changeType === 'positive' ? 'text-green-600' : 'text-red-600'
          }`}>
            <Icon 
              name={changeType === 'positive' ? 'TrendingUp' : 'TrendingDown'} 
              size={14}
            />
            <span>{change}</span>
          </div>
          <span className="text-xs text-muted-foreground">vs mois précédent</span>
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;